import { JSX } from 'react';

/**
 * Format the log details sent by API to show in readable format
 * @param {string} logMessage is log details of notification/queue
 * @param {function} t is the translation function
 * @returns {JSX.Element} the div element
 */
export const formatLogContent = (logMessage: string, t: any): JSX.Element => {
  let logText = null;

  if (logMessage === null) {
    return <div className="pt-1">{t('messages.noDataFound')}</div>;
  } else {
    // Removes all opening and closing { } brackets in message string
    // Split the string into individual lines using the '\n' delimiter
    const logLines = logMessage.replaceAll(/[{}]/g, '').split('\n');

    // Create an array of JSX elements, each representing a line
    logText = logLines?.map((line, index) => <div key={index + 1}>{line}</div>);

    return <div className="pt-1">{logText}</div>;
  }
};
